UserinfoController.$inject = ['$scope', 'User', '$rootScope', "Backoffice", 'SessionSync', '$state'];

/* @ngInject */
function UserinfoController($scope, User, $rootScope, Backoffice, SessionSync, $state) {
    var vm = this;
    vm.username = User.data.name;
    vm.avatar = User.data.avatar ? User.data.avatar : 'no-avatar.png';
    vm.userInitial = vm.username ? vm.username.charAt(0).toUpperCase() : '';

    // Methods
    vm.logout = logout.bind(this, true);
    vm.lockscreen = logout;

    activate();

    ////////////////

    function activate() {
    }

    function logout(forget) {
        return User.API.one('logout').post()
            .then(function () {
                if (forget) {
                    localStorage.removeItem('session_last');
                    Backoffice.token_manager.forget()
                    Backoffice.intercom.logOut();
                }
                
                // Notify other tabs about the logout
                SessionSync.broadcastLogout();
                
                // Handle logout for current tab immediately
                User.logout();
                $rootScope.$broadcast('session:logout:cleanup');
                
                // Redirect to login immediately for the current tab
                $state.go('login.signin');
            });
    }
}

export default UserinfoController;
